import React, { useState } from 'react';
import './PasswordModal.css';

const PasswordModal = ({ onPasswordSubmit, isOpen }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onPasswordSubmit(password);
    setError('Mot de passe incorrect');
    setPassword('');
  };

  if (!isOpen) return null;

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <h2>Accès protégé</h2>
        <p>Veuillez entrer le mot de passe pour accéder à ce projet.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            autoFocus
          />
          {error && <p className="error-message">{error}</p>}
          <button type="submit">Valider</button>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;